// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.multiplex.RentalManagerUserPropertyMultiplexWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  ListingAlias,
  UserPropertyMultiplexCreateUnitsRequestWebDto,
  UserPropertyMultiplexCreateUnitsResponseWebDto,
  UserPropertyMultiplexGetBuildingSessionDetailsResponseWebDto,
  UserPropertyMultiplexGetBuildingSessionOverviewResponseWebDto,
  UserPropertyMultiplexGetUnitNumbersResponseWebDto,
  UserPropertyMultiplexPhotoRankRequestWebDto,
  UserPropertyMultiplexPhotoResponseWebDto,
  UserPropertyMultiplexPhotoUploadRequestWebDto,
  UserPropertyMultiplexPhotoUploadResponseWebDto,
  UserPropertyMultiplexSetListingCriteriaRequestWebDto,
  UserPropertyMultiplexSetListingCriteriaResponseWebDto,
  UserPropertyMultiplexUnitPublishedResponseWebDto,
  UserPropertyMultiplexUpdateRequestWebDto,
  UserPropertyMultiplexUpdateResponseWebDto,
} from '../..';

interface CaptionParams {
  caption?: string;
  multiplexBuildingSessionId: string;
  photoId: string;
}
interface DeleteParams {
  multiplexBuildingSessionId: string;
  photoId: string;
}
interface DetailsParams {
  multiplexBuildingSessionId: string;
}
interface GetUnitNumbersParams {
  fullAddress: string;
}
interface OverviewParams {
  multiplexBuildingSessionId: string;
}
interface RankParams {
  multiplexBuildingSessionId: string;
}
interface SetListingCriteriaParams {
  multiplexBuildingSessionId: string;
}
interface UnitPublishedParams {
  listingAlias: ListingAlias;
  multiplexBuildingSessionId: string;
}
interface UpdateParams {
  multiplexBuildingSessionId: string;
}
interface UploadParams {
  multiplexBuildingSessionId: string;
}

export const RentalManagerUserPropertyMultiplexWebApiHandler_caption_Path =
  '/api/web/v1/users/properties/multiplex/photos/caption';

/**
 * Update photo caption for every unit in a multiplex building session
 */
export const RentalManagerUserPropertyMultiplexWebApiHandler_caption = (
  getParams: CaptionParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<CaptionParams, never, UserPropertyMultiplexPhotoResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyMultiplexWebApiHandler_caption_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyMultiplexWebApiHandler_create_Path =
  '/api/web/v1/users/properties/multiplex/create';

/**
 * Create units for a multiplex
 */
export const RentalManagerUserPropertyMultiplexWebApiHandler_create = (
  postData: UserPropertyMultiplexCreateUnitsRequestWebDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    UserPropertyMultiplexCreateUnitsRequestWebDto,
    UserPropertyMultiplexCreateUnitsResponseWebDto
  >(
    {
      endpoint: RentalManagerUserPropertyMultiplexWebApiHandler_create_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyMultiplexWebApiHandler_delete_Path =
  '/api/web/v1/users/properties/multiplex/photos/delete';

/**
 * Delete a photo from every unit in a multiplex building session
 */
export const RentalManagerUserPropertyMultiplexWebApiHandler_delete = (
  getParams: DeleteParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<DeleteParams, never, UserPropertyMultiplexPhotoResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyMultiplexWebApiHandler_delete_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyMultiplexWebApiHandler_details_Path =
  '/api/web/v1/users/properties/multiplex/details';

/**
 * Get property details for a multiplex building session
 */
export const RentalManagerUserPropertyMultiplexWebApiHandler_details = (
  getParams: DetailsParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<DetailsParams, never, UserPropertyMultiplexGetBuildingSessionDetailsResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyMultiplexWebApiHandler_details_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyMultiplexWebApiHandler_getUnitNumbers_Path =
  '/api/web/v1/users/properties/multiplex/getUnitNumbers';

/**
 * Get unit numbers for a multiplex
 */
export const RentalManagerUserPropertyMultiplexWebApiHandler_getUnitNumbers = (
  getParams: GetUnitNumbersParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetUnitNumbersParams, never, UserPropertyMultiplexGetUnitNumbersResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyMultiplexWebApiHandler_getUnitNumbers_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyMultiplexWebApiHandler_overview_Path =
  '/api/web/v1/users/properties/multiplex/overview';

/**
 * Get overview for a multiplex building session
 */
export const RentalManagerUserPropertyMultiplexWebApiHandler_overview = (
  getParams: OverviewParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<OverviewParams, never, UserPropertyMultiplexGetBuildingSessionOverviewResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyMultiplexWebApiHandler_overview_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyMultiplexWebApiHandler_rank_Path =
  '/api/web/v1/users/properties/multiplex/photos/rank';

/**
 * Update photo rank for every unit in a multiplex building session
 */
export const RentalManagerUserPropertyMultiplexWebApiHandler_rank = (
  getParams: RankParams,
  postData: UserPropertyMultiplexPhotoRankRequestWebDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    RankParams,
    UserPropertyMultiplexPhotoRankRequestWebDto,
    UserPropertyMultiplexPhotoResponseWebDto
  >(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyMultiplexWebApiHandler_rank_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyMultiplexWebApiHandler_setListingCriteria_Path =
  '/api/web/v1/users/properties/multiplex/setListingCriteria';

/**
 * Set listing criteria for all the units in a multiplex building session
 */
export const RentalManagerUserPropertyMultiplexWebApiHandler_setListingCriteria = (
  getParams: SetListingCriteriaParams,
  postData: UserPropertyMultiplexSetListingCriteriaRequestWebDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    SetListingCriteriaParams,
    UserPropertyMultiplexSetListingCriteriaRequestWebDto,
    UserPropertyMultiplexSetListingCriteriaResponseWebDto
  >(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyMultiplexWebApiHandler_setListingCriteria_Path,
      method: 'PUT',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyMultiplexWebApiHandler_unitPublished_Path =
  '/api/web/v1/users/properties/multiplex/unitPublished';

/**
 * Get publish summary after a multiplex unit is published
 */
export const RentalManagerUserPropertyMultiplexWebApiHandler_unitPublished = (
  getParams: UnitPublishedParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<UnitPublishedParams, never, UserPropertyMultiplexUnitPublishedResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyMultiplexWebApiHandler_unitPublished_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyMultiplexWebApiHandler_update_Path =
  '/api/web/v1/users/properties/multiplex/update';

/**
 * Update listing fields for all the units in a multiplex building session
 */
export const RentalManagerUserPropertyMultiplexWebApiHandler_update = (
  getParams: UpdateParams,
  postData: UserPropertyMultiplexUpdateRequestWebDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    UpdateParams,
    UserPropertyMultiplexUpdateRequestWebDto,
    UserPropertyMultiplexUpdateResponseWebDto
  >(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyMultiplexWebApiHandler_update_Path,
      method: 'PUT',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyMultiplexWebApiHandler_upload_Path =
  '/api/web/v1/users/properties/multiplex/photos/upload';

/**
 * Upload a photo to every unit in a multiplex building session
 */
export const RentalManagerUserPropertyMultiplexWebApiHandler_upload = (
  getParams: UploadParams,
  postData: UserPropertyMultiplexPhotoUploadRequestWebDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    UploadParams,
    UserPropertyMultiplexPhotoUploadRequestWebDto,
    UserPropertyMultiplexPhotoUploadResponseWebDto
  >(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyMultiplexWebApiHandler_upload_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
      isFormData: true,
    },
    client,
  );
};
